import React from 'react'
import { isStartDateInRange, isEndDateInRange } from '@utils/employee'
import { DateUtil } from '@utils'
import { Tooltip2 } from '@blueprintjs/popover2'

const StartEndTooltip = ({
  children,
  text,
  showTooltip,
}: {
  text: string
  showTooltip: boolean
  children: JSX.Element
}) =>
  showTooltip ? (
    <Tooltip2 placement="right" content={text}>
      {children}
    </Tooltip2>
  ) : (
    children
  )

export default function EmployeeStartEndDate({
  startDate,
  endDate,
  dateFormat = 'MMMM d',
  showTooltip,
}: {
  startDate: DateUtil
  endDate: DateUtil
  dateFormat: string
  showTooltip: boolean
}) {
  if (isStartDateInRange(startDate) && endDate) {
    return (
      <StartEndTooltip text="Employment dates" showTooltip={showTooltip}>
        <span>{`${startDate.format(dateFormat)} - ${endDate.format(dateFormat)}`}</span>
      </StartEndTooltip>
    )
  } else if (isStartDateInRange(startDate)) {
    return (
      <StartEndTooltip text="Start day" showTooltip={showTooltip}>
        <span>starting {startDate.format(dateFormat)}</span>
      </StartEndTooltip>
    )
  } else if (isEndDateInRange(endDate)) {
    return (
      <StartEndTooltip text="End day" showTooltip={showTooltip}>
        <span>leaving {endDate.format(dateFormat)}</span>
      </StartEndTooltip>
    )
  } else if (startDate && endDate) {
    return (
      <StartEndTooltip text="Employment dates" showTooltip={showTooltip}>
        <span>{`${startDate.format(dateFormat)} - ${endDate.format(dateFormat)}`}</span>
      </StartEndTooltip>
    )
  } else {
    return null
  }
}
